import { memo, useEffect } from "react";

import classNames from "classnames";

import { useSubscriptionContext } from "app/pages/activation/context/Subscription/SubscriptionProvider";
import { Subscriptions } from "app/pages/activation/components/Shared/Subscriptions/Subscriptions";
import { initialDataToSave } from "app/pages/activation/modules/Settings/config";
import type { DataToSaveSchema } from "app/pages/activation/modules/Settings/types";

import { generateAutomationName } from "../../../helpers/generateAutomationName";

import * as SC from "./styles";

type SubscriptionTabContentSchema = {
    setIsChanged: (isChanged: boolean) => void;
    setDataToSave: (data: DataToSaveSchema) => void;
};

export const SubscriptionTabContent = memo(({ setIsChanged, setDataToSave }: SubscriptionTabContentSchema) => {
    const { isChanged, onSave } = useSubscriptionContext();

    useEffect(() => {
        setIsChanged(isChanged);
        setDataToSave({ ...initialDataToSave, onSubscribe: onSave });
    }, [isChanged, onSave]);

    return (
        <SC.Section
            className={classNames("noBottomPadding", "noTopPadding")}
            data-automation={generateAutomationName("settings", ["section", "subscriptions"])}
        >
            <Subscriptions />
        </SC.Section>
    );
});

SubscriptionTabContent.displayName = "SubscriptionTabContent";
